import * as React from "react";
import { connect } from "react-redux";

import PatientInvoice from "../../screens/Patients/PatientInvoice";
import {
  PatientInvoiceList,
  // PatientInvoiceSelectedPage,
  PatientInvoiceStatusChange,
  PatientInvoiceSelectedPage
} from "./action";
class PatientInvoiceContainer extends React.Component<Props, State> {
  render() {
    return (
      <PatientInvoice
        patientInvoiceList={this.props.PatientInvoiceList}
        patientInvoiceDtlsList={this.props.patientInvoiceDtlsList}
        patientInvoiceDtlsCount={this.props.patientInvoiceDtlsCount}
        // patientInvoiceSelectedPage={this.props.PatientInvoiceSelectedPage}
        PatientInvoiceStatusChange={this.props.PatientInvoiceStatusChange}
        PatientInvoiceSelectedPage={this.props.PatientInvoiceSelectedPage}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    PatientInvoiceList: (value) => {
      dispatch(PatientInvoiceList(value));
    },

    PatientInvoiceSelectedPage: value => {
      dispatch(PatientInvoiceSelectedPage(value));
    },
    PatientInvoiceStatusChange: value => {
      dispatch(PatientInvoiceStatusChange(value));
    },
  };
}
function mapStateToProps(state) {
  return {
    patientInvoiceDtlsList: state.PatientInvoiceReducer.patientInvoiceDtlsList,
    patientInvoiceDtlsCount:
      state.PatientInvoiceReducer.patientInvoiceDtlsCount,
  };
}

export default connect(
  mapStateToProps,
  bindAction
)(PatientInvoiceContainer);
